export default {
  markers: null,
  selected: null,

  size: 1,
  showLabels: true,

  isDeletingOutsideBorder: false
}
